import { isVariantUnavailable } from '../utils/product-unavailable-utils';
import { triggerLifeCycleEvent } from '../utils/product-bundle-utils';
import { VARIANT_TYPE_CHANGED } from '../constants/index';

export const useVariantType = ({ product, variants, onChange, selectableVariantProducts = [] }) => {
  const value = product?.itemId;

  const renderComponent = variants?.length > 1;
  const items = variants?.map((variant) => {
    const isUnavailable = isVariantUnavailable(variant?.id, selectableVariantProducts, product);
    return {
      value: variant?.id,
      name: variant?.value,
      isUnavailable
    };
  }) || [];

  const handleChange = (newId) => {
    if (newId) {
      onChange(value, newId, true);
      const isUnavailable = isVariantUnavailable(newId, selectableVariantProducts, product);
      if (!isUnavailable) {
        triggerLifeCycleEvent(VARIANT_TYPE_CHANGED, { selectedFuelTypeId: newId });
      }
    }
  };

  return {
    value,
    items,
    renderComponent,
    handleChange
  };
};